export default {
    data() {
        return {
            currentlyOpenContextMenu: undefined,
        }
    },

    methods: {
        getReferralContextMenuKey(dayPeriod, index) {
            return dayPeriod ? `${dayPeriod}${index}` : index
        },

        toggleReferralContextMenu(event) {
            if (!event) return
            if (event.key === '' && event.originalEvent) {
                const parent = event.originalEvent.target.closest('.referral-context-menu-wrapper')
                if (parent) {
                    return
                }
            }

            this.currentlyOpenContextMenu = event.key || ''
        },
    },
}
